import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import store from 'store';
import on from 'dom-event';
import debounce from 'lodash.debounce';
import * as gqlQueries from 'lib/graphql/queries';
import storefront from 'lib/storefront';
import { convertGQLToProductJson, handleize, isTablet } from 'utils/general';
import { A11y, Keyboard } from 'swiper/modules';

export default (el) =>
  new Vue({
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
      'product-card-slider-swiper': () =>
        import('../product-card-slider-swiper/product-card-slider-swiper.vue'),
    },
    el,
    store,
    name: 'Featured Products',
    data: () => ({
      productHandles: el.dataset.productHandles?.split('|'),
      hasSlider: false,
      widgetData: {},
      isTablet: false,
      recommendedProducts: [],
      cardImage: false,
      swiperOptions: {
        slidesPerView: 1.6,
        loop: true,
        a11y: true,
        keyboard: true,
        modules: [Keyboard, A11y],
        on: {
          resize: function(swiper) {
            const heights = swiper.slides
              .filter(slide => !slide.className.includes('content-slide')) // Exclude content-slides from height calculation
              .map((slide) => slide.offsetHeight);
            const maxHeight = Math.max(...heights);
            swiper.slides.forEach(slide => slide.style.height = `${maxHeight}px`)
          }
        },
        breakpoints: {
          768: {
            slidesPerView: 'auto'
          }
        }
      }
    }),
    async created() {
      this.getProductsByHandles();
    },
    mounted() {
      setTimeout(() => {
        if (Boolean(this.$refs.slider?.$refs?.carousl)) {
          this.$refs.slider.$refs.carousl.resize();
        }
      }, 500);

      this.initSlider();
      this.handleResize();
      on(window, 'resize', debounce(this.handleResize), 100);
    },
    computed: {
      hasImageCard() {
        return this.$el.dataset.image;
      },
    },
    methods: {
      initSlider() {
        this.hasSlider = this.productHandles?.length > 3;
      },
      handleResize() {
        this.isTablet = isTablet();
      },
      async getProductsByHandles() {
        let tempProducts = [];
        let storefrontResponse = null;
        let collection = null;

        await Promise.all(
          this.productHandles.map(async (handle, i) => {
            storefrontResponse = await storefront.request(gqlQueries.product, {
              handle: handle,
            });
            const currentProduct = convertGQLToProductJson(
              storefrontResponse.product,
            );
            if (!currentProduct.title) return;
            const collectionHandle =
              currentProduct.title &&
              handleize(
                currentProduct.title.split(__GLOBAL__.productDelimiter)[0],
              );
            if (!collectionHandle) return;
            await storefront
              .request(gqlQueries.collectionWithVariants, {
                handle: collectionHandle,
              })
              .then(async (response) => {
                collection = response.collection?.products?.edges ?? null;
              });

            if (collection) {
              currentProduct.collections = collection;
              currentProduct.shadeCount = collection.length;
            }
            currentProduct.isRecommended = true;
            tempProducts[i] = currentProduct;
          }),
        );
        this.recommendedProducts = tempProducts.filter((product) => product.id);
      },
    },
  });
